(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-module-product-card-carousel"] && !Shopify.designMode) return;
  try {
    
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting || productRecommendationsSection.dataset.recommendationsFetched === "true") return;
        const url = productRecommendationsSection.dataset.url;

        fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {
                    productRecommendationsSection.innerHTML = recommendations.innerHTML;

                    // It is catched by view-global.js and used to re-init slick carousel
                    const event = new CustomEvent('recommendationsLoaded', {
                        detail: {
                            sectionId: productRecommendationsSection.dataset.sectionId
                        }
                    });
                    document.dispatchEvent(event);
                    productRecommendationsSection.dataset.recommendationsFetched = true;
                }
            })
            .catch(e => {
                console.error(e);
            });
    };
  
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  
    observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-product-recommendations"] && !Shopify.designMode) return;
  try {
    
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
    
        observer.unobserve(productRecommendationsSection);
    
        const url = productRecommendationsSection.dataset.url;
    
        fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
    
                window.ORW.lazyload && window.ORW.lazyload.update();
            }
        })
        .catch(e => {
            console.error(e);
        });
    };
    
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    if (!productRecommendationsSection.dataset.url || productRecommendationsSection.dataset.url == '') return
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
